import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Subject } from 'rxjs';
import { InitService } from '../service/init.service';
import { AuthorizationService } from '../auth/authorization.service';
import { WebsocketService } from '../service/websocket.service';

export const authorizationGuardFn: CanActivateFn = () => {
  const initService = inject(InitService);
  const authorizationService = inject(AuthorizationService);
  const websocketService = inject(WebsocketService);

  if (initService.isLoaded && authorizationService.userContext) {
    websocketService.connect(authorizationService.userContext.witoken);
    return true;
  }

  const emitter$ = new Subject<boolean>();
  initService.isConfigLoaded.subscribe((result) => {
    if (result) {
      initService.isLoaded$.subscribe((res) => {
        if (res && authorizationService.userContext) {
          websocketService.connect(authorizationService.userContext.witoken);
          emitter$.next(true);
        }
      });
      authorizationService.init();
    }
  });
  return emitter$;
};
